(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-objects-dashboard', {
                parent: 'dashboard',
                url: '/tab-objects-dashboard?page&sort&search&fleet&objectType',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.dashboard.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-dashboard.html',
                        controller: 'TabObjectsDashboardController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    firstAccess: true,
                    listFilter: '-1',
                    predicates: {},
                    hide: [],
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '',
                        squash: true
                    },
                    condition: {
                        value: '',
                        squash: true
                    },
                    filterUntracked: {
                        value: '-1',
                        squash: true
                    },
                    filterStatus: {
                        value: '-1',
                        squash: true
                    }

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            search: $stateParams.search,
                            filter: $stateParams.listFilter,
                            predicates: $stateParams.predicates,
                            hide: $stateParams.hide,
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType,
                            condition: $stateParams.condition,
                            filterUntracked: $stateParams.filterUntracked,
                            firstAccess: $stateParams.firstAccess
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-objects-dashboard-detail', {
                parent: 'dashboard',
                url: '/tab-objects-dashboard/{fleet}/{id}/{objType}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-dashboard-detail.html',
                        controller: 'TabObjectsDashboardDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: null,
                    fleet: null,
                    objType: null,
                    warningDateFrom: {
                        value: '',
                        squash: true
                    },
                    warningDateTo: {
                        value: '',
                        squash: true
                    },
                    warningName: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }],
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    fleetId: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }],
                    objTypeId: ['$stateParams', function ($stateParams) {
                        return $stateParams.objType;
                    }],
                    warningDetail: ['$stateParams', function ($stateParams) {
                        return {
                            warningDateFrom: $stateParams.warningDateFrom,
                            warningDateTo: $stateParams.warningDateTo,
                            warningName: $stateParams.warningName
                        }
                    }]
                }
            })
            .state('tab-objects-map', {
                parent: 'dashboard',
                url: '/tab-objects-map?fleet&objectType',
                data: {
                    authorities: [],
                    pageTitle: 'jotApp.tabObjects.dashboard.map'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-dashboard-map.html',
                        controller: 'TabObjectsMapController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {
                        value: '-1',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-objects-dashboard-edit', {
                parent: 'dashboard',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.tabObjects.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/tab-objects-dashboard/tab-objects-dashboard-dialog.html',
                        controller: 'TabObjectsDashboardDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjects', function ($stateParams, TabObjects) {
                        return TabObjects.get({id: $stateParams.id});
                    }]
                }
            });
    }

})();
